const API_BASE_URL =
  (process.env.REACT_APP_API_URL || "http://localhost:8000") + "/api";

const SKIP_CODES = [1000, 2000, 3000, 4001, 4002];

/* ---------------- FETCH WRAPPER ---------------- */
const apiFetch = async (path, options = {}) => {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    credentials: "include", // important for session cookies
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  if (!res.ok) {
    throw new Error(`Request failed: ${res.status}`);
  }

  return res.json();
};

/* ---------------- ACCOUNTING ---------------- */
export const getAccounting = (id) => apiFetch(`/accounting/${id}`);

export const getFinalAccounting = () => apiFetch(`/final-accounting`);

export const finalizeWeek = (id, payload) =>
  apiFetch(`/finalize/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

/* ---------------- IMPORTS ---------------- */
export const getImports = () => apiFetch("/imports");

export const getImportTransactions = (id) =>
  apiFetch(`/imports/${id}`).then((data) => data.transactions || []);

export const uploadImport = (formData) =>
  fetch(`${API_BASE_URL}/import`, {
    method: "POST",
    credentials: "include",
    body: formData, // formData for file uploads
  })
    .then(async (res) => {
      if (!res.ok) throw new Error(`Request failed: ${res.status}`);
      return res.json();
    })
    .then((data) => {
      if (data.import?.rows_skipped > 0) {
        alert(
          `${data.import.rows_skipped} transactions were skipped because they have already been imported.`
        );
      }
      return data.transactions;
    });

export const deleteImport = (id) =>
  apiFetch(`/imports/${id}`, { method: "DELETE" });

/* ---------------- TRANSACTIONS ---------------- */
export const getTransactionsByWeek = (id) =>
  apiFetch(`/transactions/week/${id}`);

/* ---------------- FILTERS ---------------- */
export const getFilters = () => apiFetch(`/filters`);

/* ---------------- APPROVALS ---------------- */
export const getApprovals = (id) => apiFetch(`/approvals/${id}`);

/* ---------------- RNR ---------------- */
export const getRnrs = () =>
  apiFetch(`/rnr`).then((data) => data.filter((row) => !SKIP_CODES.includes(row.code)));

/* ---------------- WEEKS ---------------- */
export const getWeeks = () => apiFetch(`/weeks`);

export const deleteWeek = (weekId) =>
  apiFetch(`/week/${weekId}`, { method: "DELETE" });